/*
* @flow
*/

import BaseGraph from '../BaseGraph'

class RevenueGraph extends BaseGraph {
  constructor(
    entityId: number,
    entityType: string,
    basicFilters: BasicFilters,
    services: Services
  ) {
    super(entityId, entityType, basicFilters)
    this.getGraphSummaryAPI =
      services.revenueStoreService.getRevenueDonutGraphSummary
  }
}

export default RevenueGraph
